import React from "react";
import { Check, Briefcase, ShieldCheck } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/common";
import { TWO_SIDES, ASSETS } from "@/data/content";

const Card = ({ data, image, accent, tint, Icon, testid, imgPosition = "center top" }) => (
  <div
    data-testid={testid}
    className="bg-white rounded-3xl border border-slate-100 soft-shadow overflow-hidden flex flex-col"
  >
    <div className="relative h-72 sm:h-80 overflow-hidden" style={{ background: tint }}>
      <img
        src={image}
        alt={data.tag}
        loading="lazy"
        decoding="async"
        className="w-full h-full object-cover"
        style={{ objectPosition: imgPosition }}
      />
      <span
        className="absolute top-4 left-4 inline-flex items-center gap-2 rounded-full bg-white/90 backdrop-blur px-3.5 py-1.5 text-xs font-bold"
        style={{ color: accent }}
      >
        <Icon className="h-3.5 w-3.5" /> {data.tag}
      </span>
    </div>
    <div className="p-7 sm:p-8">
      <h3 className="font-display text-2xl font-extrabold text-[#091630] mb-5">{data.headline}</h3>
      <ul className="space-y-3">
        {data.bullets.map((b) => (
          <li key={b} className="flex items-center gap-3 text-[15px] text-slate-600">
            <span className="h-6 w-6 rounded-full flex items-center justify-center shrink-0" style={{ background: tint }}>
              <Check className="h-3.5 w-3.5" style={{ color: accent }} />
            </span>
            {b}
          </li>
        ))}
      </ul>
    </div>
  </div>
);

export const TwoSidesSection = () => {
  return (
    <section data-testid="two-sides-section" className="relative py-20 sm:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <SectionHeading overline="Two sides, one flow" title="Built for vendors. Fair for customers." center />
        </Reveal>

        <div className="mt-14 grid md:grid-cols-2 gap-6 lg:gap-8">
          <Reveal delay={0.05} testid="for-vendors-anchor">
            <span id="for-vendors" className="block -mt-24 pt-24" aria-hidden />
            <Card
              data={TWO_SIDES.vendor}
              image={ASSETS.vendor}
              accent="#16a34a"
              tint="#ecfdf3"
              Icon={Briefcase}
              testid="vendor-side-card"
              imgPosition="50% 20%"
            />
          </Reveal>
          <Reveal delay={0.12} testid="for-customers-anchor">
            <span id="for-customers" className="block -mt-24 pt-24" aria-hidden />
            <Card
              data={TWO_SIDES.customer}
              image={ASSETS.customer}
              accent="#0891b2"
              tint="#ecfeff"
              Icon={ShieldCheck}
              testid="customer-side-card"
              imgPosition="50% 27%"
            />
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default TwoSidesSection;
